import { TranslateModule } from '@ngx-translate/core';
import { LottieModule } from 'ngx-lottie';
import { ChatRatingBarComponent } from './chat-rating-bar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatLevelUpPopupModule } from '../chat-levelup-popup/chat-levelup-popup.module';

@NgModule({
  declarations: [ChatRatingBarComponent],
  imports: [
    CommonModule,
    LottieModule,
    TranslateModule,
    ChatLevelUpPopupModule,
  ],
  exports: [ChatRatingBarComponent],
})
export class ChatRatingBarModule {}
